import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

export const initialState = {
  hasSeenPracticeOnboarding: false,
  hasSeenQuestOnboarding: false,
  lastLevelMastered: 0,
};

const sessionReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.SET_LAST_LEVEL_MASTERED:
      return {
        ...state,
        lastLevelMastered: action.payload.level,
      };
    case REDUX_ACTIONS.SET_HAS_SEEN_ONBOARDING: {
      const { isQuestWorkflow } = action.payload;

      return {
        ...state,
        hasSeenPracticeOnboarding: !isQuestWorkflow || state.hasSeenPracticeOnboarding,
        hasSeenQuestOnboarding: isQuestWorkflow || state.hasSeenQuestOnboarding,
      };
    }
    default:
      return state;
  }
};

export default sessionReducer;
